//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
(function () {
    'use strict';

    angular
        .module('container.core')
        .factory('localStorageService', localStorageService)
    ;

    function localStorageService() {
        var service = {
            set: set,
            get: get,
            remove: remove
        };
        return service;


        function set(key, value) {
            localStorage.setItem(key, angular.toJson(value));
        }

        function get(key) {
            return angular.fromJson(localStorage.getItem(key));
        }

        function remove(key) {
            localStorage.removeItem(key);
        }
    }

})();